import React, { useState } from 'react';
import get from 'lodash/get';
import Axios from 'axios';
import { Link } from 'gatsby';
import Select from 'react-select';
import UploadImgComponent from './UploadImgComponent';
import { getPresignedUrl, getLpgInfo } from '../../../common/constants/api';
import { getUserId } from '../../../common/utils/cookie-utils';
import { getFileValidationError } from '../AddressProof/checkFileUploadCriteria';

import Checked from '../../../images/icons/checkbox_ok.svg';
import Onload from '../../../images/icons/loading2.svg';
import NotOK from '../../../images/icons/verification_failed.svg';
import CommonInput from './CommonInput';
import UploadView from './UploadView';
import { useCheckFileAndUpdateError } from '../AddressProof/checkFileUploadCriteria';
import '../AddressProof/LpgGasUpload.css';

const UtilityOptionsUpload = props => {
  const {
    data,
    errors,
    touched,
    setData,
    setTouched,
    options,
    uploadTxt,
    handleChange,
    name,
    setFileUploadErrors,
    fileUploadErrors,
    setFieldTouched
  } = props;

  const fileCheck = useCheckFileAndUpdateError({
    data,
    fileUploadErrors,
    setFileUploadErrors,
    name
  });

  async function onChange(imgUrl, files, e) {
    data.utilityBill.files = files;
    data.utilityBill.imgUrl[0] = imgUrl;
    setData('utilityBill', {
      ...data.utilityBill,
      imgUrl: data.utilityBill.imgUrl,
      files: data.utilityBill.files
    });
    fileCheck(files); // start valiodation from here
  }
  const { imgUrl } = data.utilityBill;
  const isImageUploadedLocally = imgUrl && imgUrl[0];
  const [selectedOption, setSelectOption] = useState('');
  const [showupload, setShowupload] = useState(false);
  function handleSelectOption(selectData) {
    if (selectData.value) {
      setShowupload(true);

      setSelectOption(selectData);
      // setData("utilityBill.utilityServiceProvider", data.value);

      setData('utilityBill', {
        ...data.utilityBill,
        consumerID: '',
        buisnessPartnerNo: '',
        imgUrl: [],
        files: '',
        utilityServiceProvider: selectData.value

        // utilityBillType: data.utilityBill.utilityBillType
      });
      if (setFieldTouched) {
        setFieldTouched('utilityBill.consumerID', false, false);
        setFieldTouched('utilityBill.buisnessPartnerNo', false, false);
      }
    }
  }

  return (
    <>
      <div className="  ">
        <div className="select_service_provider text-left mt-12 w-56">
          <label
            htmlFor=""
            className="text-sm text-left text-black-400 font-bold text-roboto"
          >
            Select Service Provider
          </label>
          <div className="shadow mt-2 w-56 xl:w-48">
            <Select
              className="absolute  text-grey-300 font-light font-roboto"
              options={options || []}
              placeholder="Select"
              value={selectedOption}
              onChange={data => {
                setData('utilityBill', {
                  // ...data.utilityBill
                });
                if (setTouched) {
                  // setTouched(
                  //   { ...touched, "utilityBill.utilityServiceProvider": true },
                  //   false
                  // );
                }
                handleSelectOption(data);
              }}
            />
          </div>
        </div>

        {showupload && (
          <>
            <div
              className="mt-10 sm:mt-24"
              style={{
                width: '300px',
                margin: '70px auto 0px auto'
              }}
            >
              {props.children}

              <div className=" my-10">
                <div></div>
                {isImageUploadedLocally && (
                  <>
                    <img
                      style={{ height: '200px', width: '100%' }}
                      className="cursor-pointer"
                      src={imgUrl[0]}
                      onClick={e => {
                        if (imgUrl[0]) {
                          window.open(imgUrl[0], '_blank');
                        }
                      }}
                      alt=""
                    />
                    <div style={{ gridColumn: '2' }} className="pt-10">
                      <UploadImgComponent
                        value={data.utilityBill.files}
                        onChange={(imgUrl, files, e) => {
                          if (handleChange) {
                            handleChange(e);
                          }
                          onChange(imgUrl, files, e);
                        }}
                        name={name}
                      >
                        <p>
                          {data.utilityBill.files[0] &&
                            data.utilityBill.files[0].name}
                        </p>

                        {get(touched, 'utilityBill.files', false) &&
                          get(fileUploadErrors, 'utilityBill.files', false) && (
                            <p className="text-red-100">
                              {fileUploadErrors['utilityBill.files']}
                            </p>
                          )}
                        <p>Re-upload</p>
                      </UploadImgComponent>
                    </div>
                  </>
                )}

                {!isImageUploadedLocally && (
                  <UploadImgComponent
                    value={data.utilityBill.files}
                    onChange={(imgUrl, files, e) => {
                      if (handleChange) {
                        handleChange(e);
                      }

                      onChange(imgUrl, files, e);
                    }}
                    name={name}
                  >
                    <p>
                      {data.utilityBill.files[0] &&
                        data.utilityBill.files[0].name}
                    </p>
                    <UploadView
                      subtext={uploadTxt}
                      error={
                        get(touched, 'utilityBill.files', false) &&
                        get(fileUploadErrors, 'utilityBill.files', false) && (
                          <p className="text-red-100">
                            {fileUploadErrors['utilityBill.files']}
                          </p>
                        )
                      }
                    />
                  </UploadImgComponent>
                )}
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default UtilityOptionsUpload;
